<script>
    // -- IMPORT

    import { draw } from "svelte/transition";

    // -- CONSTANTS

    /** @type {{isMobileNavigationOpen: any}} */
    let { isMobileNavigationOpen } = $props();
</script>

<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    {#if isMobileNavigationOpen}
        <path in:draw={ { duration: 250 } } d="M6 6L42 42" stroke="#ADA690" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
        <path in:draw={ { duration: 250 } } d="M42 6L6 42" stroke="#ADA690" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
    {:else}
        <path in:draw={ { duration: 250 } } d="M6 12H42" stroke="#ADA58C" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
        <path in:draw={ { duration: 250 } } d="M6 24H42" stroke="#ADA58C" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
        <path in:draw={ { duration: 250 } } d="M6 36H42" stroke="#ADA58C" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
    {/if}
</svg>
